import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-4 mt-7" },
    [
      _c("SelectModuleButton", {
        staticClass: "py-1",
        attrs: {
          "data-qa": "service_select_synonym_button",
          title: _vm.selectedSynonym.name,
          subtitle: _vm.getFormattedPrice(_vm.selectedSynonym.price),
        },
        on: { click: _vm.handleClickSelect },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function () {
              return [
                _vm.isUsedClub
                  ? [
                      _vm.formattedSelectedSynonym.priceWithDiscount
                        ? _c(
                            "span",
                            { staticClass: "error--text pr-1" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.getFormattedPrice(
                                      _vm.formattedSelectedSynonym
                                        .priceWithDiscount
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.selectedSynonym.duration
                                ? [
                                    _vm._v(
                                      "\n            • " +
                                        _vm._s(
                                          _vm.getDurationText(
                                            _vm.selectedSynonym.duration
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: {
                            "text-decoration-line-through":
                              _vm.formattedSelectedSynonym.priceWithDiscount,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getFormattedPrice(_vm.selectedSynonym.price)
                              ) +
                              "\n          "
                          ),
                          _vm.selectedSynonym.duration
                            ? [
                                _vm._v(
                                  "\n            • " +
                                    _vm._s(
                                      _vm.getDurationText(
                                        _vm.selectedSynonym.duration
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.getFormattedPrice(_vm.selectedSynonym.price)
                          ) +
                          "\n        "
                      ),
                      _vm.selectedSynonym.duration
                        ? [
                            _vm._v(
                              "\n          • " +
                                _vm._s(
                                  _vm.getDurationText(
                                    _vm.selectedSynonym.duration
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        : _vm._e(),
                    ],
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "CoreDialog",
        {
          attrs: {
            "data-qa": "service_select_synonym_error",
            size: "sm",
            title: "Произошла ошибка",
          },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "modal-actions-btn-close",
                        color: "primary",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.isVisibleError = false
                        },
                      },
                    },
                    [_vm._v("\n        Понятно\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.isVisibleError,
            callback: function ($$v) {
              _vm.isVisibleError = $$v
            },
            expression: "isVisibleError",
          },
        },
        [
          _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
            _vm._v("\n      Попробуйте ещё раз.\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "SideMenu",
        {
          attrs: {
            title: _vm.modalTitle,
            "side-menu-width": "650px",
            "is-btn-back": !_vm.isStackRoot,
            value: _vm.isVisibleModal,
            "side-menu-auto-scroll-y": "",
          },
          on: {
            "side-menu:click-close": _vm.handleClickModalBack,
            "side-menu:click-back": _vm.handleClickModalBack,
          },
          scopedSlots: _vm._u([
            {
              key: "header-bottom",
              fn: function () {
                return [
                  _c("SynonymListSearch", {
                    ref: "synonymListSearchComponent",
                    staticClass: "pb-2",
                    attrs: {
                      "synonym-data": _vm.ajaxSynonymData,
                      "is-loading": _vm.isLoadingSynonym,
                    },
                    on: {
                      "search:found-results": _vm.handleSearchFoundResults,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.isSearchResultsEmpty
            ? _c("SynonymListSearchEmpty")
            : _c("SynonymListItems", {
                attrs: {
                  "is-used-club": _vm.isUsedClub,
                  "synonym-list": _vm.activeSynonymList,
                  "diagnostic-level": _vm.diagnosticLevel,
                  "is-loading-synonym": _vm.isLoadingSynonym,
                  "is-search-results": _vm.hasSearchResults,
                },
                on: { "synonym-list:click-item": _vm.handleClickSynonymItem },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }